import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const QuestionMarkOutlineIcon: FC<IconProps> = ({color = theme.palette.gray[400], size}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.75 8.25C8.75 7.55965 9.30965 7 10 7C10.6904 7 11.25 7.55965 11.25 8.25C11.25 8.76901 10.9279 9.27215 10.4799 9.70338C10.227 9.94683 9.94308 10.1684 9.6378 10.3433L9.63687 10.3438C9.27521 10.5439 9.14352 10.9991 9.34283 11.3614C9.54245 11.7244 9.9985 11.8568 10.3614 11.6572C10.4911 11.5858 10.6156 11.5041 10.7374 11.4204C10.9489 11.2749 11.2331 11.0604 11.5201 10.7841C12.0721 10.2529 12.75 9.38099 12.75 8.25C12.75 6.73122 11.5188 5.5 10 5.5C8.48122 5.5 7.25 6.73122 7.25 8.25C7.25 8.66422 7.58578 9 8 9C8.41422 9 8.75 8.66422 8.75 8.25Z"
          fill={color}
        />
        <path
          d="M10.75 13.75C10.75 14.1642 10.4142 14.5 10 14.5C9.58578 14.5 9.25 14.1642 9.25 13.75C9.25 13.3358 9.58578 13 10 13C10.4142 13 10.75 13.3358 10.75 13.75Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19ZM17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
